<template>
  <div class="Cart wide-container">
    <!-- 1. 顶部标题与协议提示条 -->
    <div class="cart-header-bar">
      <div class="header-left">
        <span class="header-accent-bar"></span>
        <h1 class="header-title">购物车</h1>
        <span class="header-count" v-if="orderList.length">({{ orderList.length }} 项)</span>
      </div>
      <div class="header-right">
        <i class="el-icon-time time-icon"></i>
        <span>采购价格依据企业框架协议底价实时执行 · 支持专票月结</span>
      </div>
    </div>

    <!-- 2. 购物车表格内容区 (白底卡片 + 微边框 + 柔和阴影) -->
    <div class="cart-card" v-if="orderList.length > 0">
      <!-- 表头设计 (12 栅格对齐) -->
      <div class="table-header-grid">
        <div class="col-select">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
          >
            <span class="select-all-label">全选</span>
          </el-checkbox>
        </div>
        <div class="col-info">商品信息与规格</div>
        <div class="col-price">协议单价</div>
        <div class="col-unit">计量单位</div>
        <div class="col-num">采购数量</div>
        <div class="col-action">操作</div>
      </div>

      <!-- 商品行列表 -->
      <div class="goods-row-list">
        <div
          v-for="item in orderList"
          :key="'order' + item.id"
          :class="['goods-row', { 'is-checked': item.checked }]"
        >
          <!-- 勾选框 -->
          <div class="col-select">
            <el-checkbox
              v-model="item.checked"
              @change="handleCheckedChange"
            ></el-checkbox>
          </div>

          <!-- 商品信息 -->
          <div class="col-info">
            <div class="goods-thumb-box" @click="goToDetail(item)">
              <img
                :src="getGoodsImage(item)"
                alt="商品图片"
                class="thumb-img"
              />
            </div>
            <div class="goods-meta-info">
              <h3 class="goods-title" @click="goToDetail(item)" :title="getGoodsName(item)">
                {{ getGoodsName(item) }}
              </h3>
              <div class="goods-sku-row" v-if="getSku(item)">
                <span class="sku-tag">SKU: {{ getSku(item) }}</span>
                <span class="sku-hint">框架协议入库品类</span>
              </div>
            </div>
          </div>

          <!-- 协议单价 -->
          <div class="col-price">
            <div class="price-box tabular-nums">
              <span class="currency">¥</span>
              <span class="amount">{{ formatPrice(item.qajsmihzqxevgihj) }}</span>
            </div>
          </div>

          <!-- 计量单位 -->
          <div class="col-unit">
            <span class="unit-text">{{ item.ycqgzdztcyhqnczy || '件' }}</span>
          </div>

          <!-- 采购数量 (保留原有 NumberInput 步进器) -->
          <div class="col-num">
            <div class="stepper-box">
              <NumberInput
                @changeHandle="numberChange(item)"
                :initNum="item.tbdn8rpen3ijbiv2"
                v-model="item.tbdn8rpen3ijbiv2"
                :min="1"
                :max="99999"
              />
            </div>
          </div>

          <!-- 操作 -->
          <div class="col-action">
            <button
              class="del-btn"
              @click="deleteOrder(item.id)"
              type="button"
              title="从购物车移除"
            >
              <i class="el-icon-delete del-icon"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 3. 底部结算常驻操作栏 -->
    <div class="cart-settle-bar" v-if="orderList.length > 0">
      <div class="settle-left">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
        >
          <span class="settle-select-text">
            全选 (已选 <strong class="highlight">{{ selectedCount }}</strong> 项共 <strong class="highlight">{{ selectedQuantity }}</strong> 件)
          </span>
        </el-checkbox>

        <span class="divider">|</span>

        <button
          class="batch-del-btn"
          @click="batchDelete"
          type="button"
          :disabled="selectedCount === 0"
        >
          <i class="el-icon-delete"></i>
          <span>批量删除</span>
        </button>
      </div>

      <div class="settle-right">
        <div class="summary-box">
          <div class="price-row">
            <span class="summary-label">应付预估总额:</span>
            <div class="total-price tabular-nums">
              <span class="currency">¥</span>
              <span class="amount">{{ totalAmount }}</span>
            </div>
          </div>
          <div class="summary-hint">已享专属协议折扣 · 支持对公转账/额度月结扣减</div>
        </div>

        <button
          class="checkout-btn"
          @click="settleAccounts"
          type="button"
          :disabled="selectedCount === 0"
        >
          <span>立即下单</span>
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- 4. 购物车空状态 -->
    <div class="empty-cart-card" v-else>
      <div class="empty-icon-wrap">
        <img src="../../assets/img/cart.svg" alt="购物车为空" class="empty-img" />
      </div>
      <h3 class="empty-title">您的购物车暂无商品</h3>
      <p class="empty-desc">浏览企业协议目录，精选正品直供现货随时加入购物车</p>
      <button class="empty-action-btn" @click="navTo('/mall/show/goodsList/1/all')" type="button">
        <span>选购协议商品</span>
        <i class="el-icon-arrow-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
import NumberInput from "../../components/NumberInput";
import {
  online,
  delOnline,
  updateOnline,
} from "@/api/platform";

export default {
  name: "Cart",
  components: {
    NumberInput,
  },
  data () {
    return {
      form_head_uuid: "a6cf518450fb43289af179b8beb4b943",
      orderList: [],
      checkAll: false,
      isIndeterminate: false,
    };
  },
  computed: {
    selectedItems () {
      return this.orderList.filter((item) => item.checked);
    },
    selectedCount () {
      return this.selectedItems.length;
    },
    selectedQuantity () {
      return this.selectedItems.reduce((acc, item) => {
        const qty = Number(item.tbdn8rpen3ijbiv2) || 0;
        return acc + qty;
      }, 0);
    },
    totalAmount () {
      let amount = 0;
      this.selectedItems.forEach((item) => {
        const price = Number(item.qajsmihzqxevgihj) || 0;
        const qty = Number(item.tbdn8rpen3ijbiv2) || 0;
        amount += price * qty;
      });
      return amount.toFixed(2);
    },
  },
  created () {
    this.$store.dispatch('getCartQuantity');
  },
  mounted () {
    this.getShoppingCartList();
  },
  methods: {
    // 全选切换
    handleCheckAllChange () {
      this.orderList = this.orderList.map((item) => {
        return {
          ...item,
          checked: this.checkAll,
        };
      });
      this.isIndeterminate = false;
    },
    // 单选切换
    handleCheckedChange () {
      const checkedCount = this.selectedCount;
      const totalCount = this.orderList.length;
      this.checkAll = checkedCount === totalCount && totalCount > 0;
      this.isIndeterminate = checkedCount > 0 && checkedCount < totalCount;
    },
    // 获取购物车真实列表
    async getShoppingCartList () {
      const { form_head_uuid } = this;
      const { result } = await online({
        page: 1,
        limit: 100,
        keyword: "",
        select_option: "",
        form_head_uuid,
      });
      if (Array.isArray(result) && result.length > 0) {
        this.orderList = result.map((el) => ({
          ...el,
          checked: false,
        }));
      } else {
        this.orderList = [];
      }
      this.handleCheckedChange();
    },
    // 数量调整
    async numberChange (item) {
      const { form_head_uuid } = this;
      const { id } = item;
      await updateOnline({
        id,
        form_head_uuid,
        tbdn8rpen3ijbiv2: item.tbdn8rpen3ijbiv2,
      });
      this.$store.dispatch('getCartQuantity');
    },
    // 单项删除
    async deleteOrder (orderId) {
      this.$confirm('确认从购物车中移除该商品吗？', '移除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const { form_head_uuid } = this;
        await delOnline({
          form_head_uuid,
          ids: [orderId],
        });
        this.$message.success('已移除该商品');
        this.getShoppingCartList();
        this.$store.dispatch('getCartQuantity');
      }).catch(() => {});
    },
    // 批量删除已勾选
    async batchDelete () {
      const selectedIds = this.selectedItems.map((item) => item.id);
      if (!selectedIds.length) {
        return this.$message.warning('请先勾选需要移除的商品');
      }
      this.$confirm(`确认从购物车中移除已勾选的 ${selectedIds.length} 项商品吗？`, '批量移除', {
        confirmButtonText: '确定移除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await delOnline({
          form_head_uuid: this.form_head_uuid,
          ids: selectedIds,
        });
        this.$message.success('已批量移除已选商品');
        this.getShoppingCartList();
        this.$store.dispatch('getCartQuantity');
      }).catch(() => {});
    },
    // 下单结算
    async settleAccounts () {
      const commodityList = this.orderList.filter((el) => el.checked);
      if (commodityList && commodityList.length > 0) {
        this.$store.commit('setData', {
          commodityList,
        });
        this.$router.push('/mall/createOrder?form=cart');
      } else {
        return this.$notify.error({
          title: '提示',
          message: '您还没有选择商品',
        });
      }
    },
    // 路由跳转
    navTo (route) {
      this.$router.push(route);
    },
    goToDetail (item) {
      if (item && item.duovdnoapszqxeih && item.duovdnoapszqxeih.length > 0) {
        this.navTo('/mall/goods/' + item.duovdnoapszqxeih[0].id);
      }
    },
    // 数据辅助提取
    getGoodsName (item) {
      if (!item) return '';
      if (item.duovdnoapszqxeih && item.duovdnoapszqxeih.length > 0) {
        return item.duovdnoapszqxeih[0].value;
      }
      return item.goodsName || '协议商品';
    },
    getGoodsImage (item) {
      if (!item) return '';
      if (item.gdlu2l0z6a7sprky && item.gdlu2l0z6a7sprky.length > 0) {
        return item.gdlu2l0z6a7sprky[0].url;
      }
      return '';
    },
    getSku (item) {
      if (!item) return '';
      return item.tygpzkobrzzhltwd || item.sku || item.goodsNo || item.levmoblohezp7y50 || '';
    },
    formatPrice (val) {
      const num = Number(val);
      if (isNaN(num)) return '0.00';
      return num.toFixed(2);
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.Cart {
  padding: 24px 0 60px;

  // 1. 顶部标题栏
  .cart-header-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    .header-left {
      display: flex;
      align-items: center;
      gap: 10px;

      .header-accent-bar {
        width: 4px;
        height: 18px;
        background-color: @brandPrimary;
        border-radius: 2px;
      }

      .header-title {
        font-size: 18px;
        font-weight: 700;
        color: @brandTextDark;
        margin: 0;
        letter-spacing: -0.01em;
      }

      .header-count {
        font-size: 13px;
        font-weight: 500;
        color: @brandTextLight;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      color: @brandTextMuted;

      .time-icon {
        font-size: 14px;
        color: @brandTextLight;
      }
    }
  }

  // 2. 购物车表格卡片
  .cart-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid @brandBorder;
    box-shadow: 0 2px 10px rgba(0, 40, 100, 0.03);
    overflow: hidden;

    // 12 列栅格分配基准
    .col-select {
      width: 70px;
      padding-left: 20px;
      flex-shrink: 0;
    }
    .col-info {
      flex: 1;
      min-width: 0;
      padding-right: 20px;
    }
    .col-price {
      width: 140px;
      text-align: center;
      flex-shrink: 0;
    }
    .col-unit {
      width: 90px;
      text-align: center;
      flex-shrink: 0;
    }
    .col-num {
      width: 160px;
      text-align: center;
      flex-shrink: 0;
    }
    .col-action {
      width: 80px;
      text-align: center;
      flex-shrink: 0;
    }

    // 表头
    .table-header-grid {
      display: flex;
      align-items: center;
      height: 46px;
      background-color: #f8fafc;
      border-bottom: 1px solid @brandBorder;
      font-size: 12px;
      font-weight: 600;
      color: @brandTextMuted;

      .select-all-label {
        margin-left: 6px;
        font-size: 12px;
        color: @brandTextBase;
        user-select: none;
      }
    }

    // 商品列表行
    .goods-row-list {
      .goods-row {
        display: flex;
        align-items: center;
        padding: 18px 0;
        border-bottom: 1px solid #f1f5f9;
        transition: background-color 0.15s ease;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background-color: #fafcff;
        }

        &.is-checked {
          background-color: #f6f9fe;
        }

        // 商品信息单元
        .col-info {
          display: flex;
          align-items: center;
          gap: 14px;

          .goods-thumb-box {
            width: 56px;
            height: 56px;
            border-radius: 8px;
            border: 1px solid @brandBorderLight;
            background-color: #ffffff;
            padding: 4px;
            box-sizing: border-box;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: border-color 0.15s ease;

            &:hover {
              border-color: @brandContainer;
            }

            .thumb-img {
              width: 100%;
              height: 100%;
              object-contain: contain;
            }
          }

          .goods-meta-info {
            flex: 1;
            min-width: 0;

            .goods-title {
              font-size: 13px;
              font-weight: 600;
              color: @brandTextDark;
              margin: 0 0 4px;
              line-height: 1.4;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              transition: color 0.15s ease;

              &:hover {
                color: @brandContainer;
              }
            }

            .goods-sku-row {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 11px;
              color: @brandTextLight;

              .sku-tag {
                background-color: #f1f5f9;
                padding: 1px 6px;
                border-radius: 4px;
                font-family: inherit;
              }

              .sku-hint {
                color: #94a3b8;
              }
            }
          }
        }

        // 协议单价
        .col-price {
          .price-box {
            font-size: 15px;
            font-weight: 700;
            color: @brandTextDark;

            .currency {
              font-size: 12px;
              font-weight: 600;
              margin-right: 2px;
              color: @brandPrimary;
            }

            .amount {
              color: @brandPrimary;
            }
          }
        }

        // 单位
        .col-unit {
          font-size: 13px;
          color: @brandTextMuted;
        }

        // 数量步进
        .col-num {
          display: flex;
          justify-content: center;

          .stepper-box {
            display: inline-block;
          }
        }

        // 删除按钮
        .col-action {
          .del-btn {
            border: none;
            background: transparent;
            width: 32px;
            height: 32px;
            border-radius: 6px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #94a3b8;
            cursor: pointer;
            transition: all 0.15s ease;

            .del-icon {
              font-size: 16px;
            }

            &:hover {
              color: #ef4444;
              background-color: #fee2e2;
            }
          }
        }
      }
    }
  }

  // 3. 底部结算常驻操作栏
  .cart-settle-bar {
    margin-top: 18px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid @brandBorder;
    box-shadow: 0 4px 14px rgba(0, 40, 100, 0.05);
    padding: 14px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .settle-left {
      display: flex;
      align-items: center;
      gap: 16px;

      .settle-select-text {
        font-size: 13px;
        color: @brandTextBase;

        .highlight {
          color: @brandPrimary;
          font-weight: 700;
          margin: 0 2px;
        }
      }

      .divider {
        color: #e2e8f0;
      }

      .batch-del-btn {
        border: none;
        background: transparent;
        color: @brandTextLight;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: 6px;
        transition: all 0.15s ease;

        &:hover:not(:disabled) {
          color: #ef4444;
          background-color: #fee2e2;
        }

        &:disabled {
          color: #cbd5e1;
          cursor: not-allowed;
        }
      }
    }

    .settle-right {
      display: flex;
      align-items: center;
      gap: 20px;

      .summary-box {
        text-align: right;

        .price-row {
          display: flex;
          align-items: baseline;
          justify-content: flex-end;
          gap: 6px;

          .summary-label {
            font-size: 13px;
            font-weight: 500;
            color: @brandTextMuted;
          }

          .total-price {
            font-size: 24px;
            font-weight: 800;
            color: @brandPrimary;
            letter-spacing: -0.02em;

            .currency {
              font-size: 16px;
              font-weight: 700;
              margin-right: 2px;
            }
          }
        }

        .summary-hint {
          font-size: 11px;
          color: #94a3b8;
          margin-top: 2px;
        }
      }

      .checkout-btn {
        height: 44px;
        padding: 0 32px;
        background-color: @brandPrimary;
        color: #ffffff;
        border: none;
        border-radius: 8px;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 6px;
        box-shadow: 0 2px 8px rgba(0, 60, 144, 0.25);
        transition: all 0.2s ease;

        &:hover:not(:disabled) {
          background-color: @brandDark;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 60, 144, 0.35);
        }

        &:disabled {
          background-color: #cbd5e1;
          cursor: not-allowed;
          box-shadow: none;
        }
      }
    }
  }

  // 4. 购物车空状态
  .empty-cart-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid @brandBorder;
    padding: 80px 20px;
    text-align: center;

    .empty-icon-wrap {
      width: 80px;
      height: 80px;
      margin: 0 auto 16px;
      border-radius: 50%;
      background-color: #f8fafc;
      display: flex;
      align-items: center;
      justify-content: center;

      .empty-img {
        width: 44px;
        height: 44px;
        opacity: 0.6;
      }
    }

    .empty-title {
      font-size: 16px;
      font-weight: 700;
      color: @brandTextDark;
      margin: 0 0 6px;
    }

    .empty-desc {
      font-size: 13px;
      color: @brandTextLight;
      margin: 0 0 20px;
    }

    .empty-action-btn {
      height: 38px;
      padding: 0 20px;
      background-color: @brandPrimary;
      color: #ffffff;
      border: none;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      transition: all 0.15s ease;

      &:hover {
        background-color: @brandDark;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Cart.vue